<link rel="stylesheet" [href]='cssUrl' type="text/css" *ngIf="cssUrl !=null">
<div>
  <router-outlet>
  </router-outlet>
</div>
